<template>
	<div :class="['c-popup', { active: showMenu }]">
		<transition>
			<div class="c-popup__inner">
				<slot name="links">
					<!-- <router-link to="/profile" v-if="user && user.avatar">
						<img
							:title="`${user.name}'s profile`"
							:src="`${assetUrl}/${user.avatar.name}`"
						/>
						<article>
							<p>{{ user.name }} {{ user.lastName }}</p>
							<span>
								{{ user.email }}
							</span>
						</article>
					</router-link> -->
					<h6>Create</h6>
					<ul>
						<li>
							<a href="#" class="btn" @click.prevent="onUploadAds">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M20 12.75V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V12.75M12 4V15.25M12 4L16.5 8.5M12 4L7.5 8.5"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								Upload ads
							</a>
						</li>
						<li>
							<a href="#" class="btn" @click.prevent="onCreateBoard">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Create board
							</a>
						</li>
					</ul>
					<h6>Links</h6>
					<ul>
						<li>
							<router-link to="/tags" class="btn" @click.native="closeMenu">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M20.8844 10.6984L16.5986 5.69842C16.2187 5.25513 15.664 5 15.0801 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H15.0801C15.664 19 16.2187 18.7449 16.5986 18.3016L20.8844 13.3016C21.5263 12.5526 21.5263 11.4474 20.8844 10.6984Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="white"/>
									<path d="M16.5 12C16.5 12.8284 15.8284 13.5 15 13.5C14.1716 13.5 13.5 12.8284 13.5 12C13.5 11.1716 14.1716 10.5 15 10.5C15.8284 10.5 16.5 11.1716 16.5 12Z" stroke="white"/>
								</svg>
								Tag manager
							</router-link>
						</li>
						<li>
							<router-link to="/profile" class="btn">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M4 18.8C4 16.149 6.14903 14 8.8 14H15.2C17.851 14 20 16.149 20 18.8V18.8C20 20.5673 18.5673 22 16.8 22H7.2C5.43269 22 4 20.5673 4 18.8V18.8Z"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								Settings
							</router-link>
						</li>
						<li>
							<router-link to="/mcp" class="btn">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									fill="none"
								>
									<path
										d="M11.0533 2.79347C12.4449 1.40182 14.7017 1.40188 16.0933 2.79347L16.2193 2.92628C16.9519 3.73696 17.2448 4.80308 17.1002 5.81886C18.1172 5.67274 19.1848 5.96602 19.9966 6.69972L20.1294 6.82569L20.1714 6.86769L20.2974 7.0005C21.5615 8.3994 21.5197 10.5595 20.1714 11.9077L12.8785 19.2007C12.786 19.2935 12.7858 19.444 12.8785 19.5366L14.3755 21.0337C14.6538 21.312 14.6538 21.7632 14.3755 22.0415C14.0972 22.3196 13.646 22.3198 13.3677 22.0415L11.8707 20.5444C11.2213 19.8951 11.2215 18.8423 11.8707 18.1929L19.1627 10.8999C19.9456 10.1171 19.9952 8.87744 19.3101 8.03761L19.1627 7.8755L19.1207 7.83351C18.2856 6.99932 16.932 6.99885 16.0972 7.83351L10.0914 13.8394C10.085 13.8458 10.0765 13.8499 10.0699 13.856L10.0035 13.9234C9.72519 14.2014 9.27393 14.2014 8.99566 13.9234C8.71756 13.6451 8.71763 13.1939 8.99566 12.9155L15.0855 6.82569C15.9205 5.99069 15.9205 4.63629 15.0855 3.80128C14.2505 2.96644 12.8961 2.96629 12.0611 3.80128L3.99761 11.8648C3.71926 12.143 3.2681 12.1431 2.9898 11.8648C2.71179 11.5864 2.71167 11.1352 2.9898 10.8569L11.0533 2.79347Z"
										fill="currentColor"
									/>
									<path
										d="M13.0777 4.80909C13.356 4.53092 13.8072 4.53098 14.0855 4.80909C14.3638 5.0874 14.3637 5.53856 14.0855 5.81691L8.12164 11.7808C7.28687 12.6156 7.28712 13.9691 8.12164 14.8042C8.95667 15.6392 10.311 15.6392 11.146 14.8042L17.1099 8.84132C17.3882 8.56315 17.8394 8.56321 18.1177 8.84132C18.3956 9.11965 18.3958 9.57091 18.1177 9.84913L12.1539 15.813C10.7622 17.2045 8.50553 17.2044 7.11382 15.813C5.72238 14.4213 5.72225 12.1646 7.11382 10.773L13.0777 4.80909Z"
										fill="currentColor"
									/>
								</svg>
								MCP
							</router-link>
						</li>
						<li>
							<a @click.prevent="onLogout" href="#" class="btn">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M12 2V12M16 4.93555C18.9634 6.40825 21 9.46631 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.46631 5.03656 6.40825 8 4.93555"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
									/>
								</svg>
								Logout
							</a>
						</li>
					</ul>
					<h6>Supported ad libraries</h6>
					<ul>
						<li>
							<a
								class="btn"
								href="https://www.facebook.com/ads/library"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>

								Facebook Ad Library
							</a>
						</li>
						<li>
							<a class="btn" href="https://www.instagram.com" target="_blank">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>

								Instagram organic
							</a>
						</li>
						<li>
							<a class="btn" href="https://tiktok.com" target="_blank">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Tiktok organic
							</a>
						</li>
						<li>
							<a
								class="btn"
								href="https://ads.tiktok.com/business/creativecenter"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Tiktok Creative Center
							</a>
						</li>
						<li>
							<a
								class="btn"
								href="https://library.tiktok.com/ads"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Tiktok Ad Library(EU only)
							</a>
						</li>
						<li>
							<a
								class="btn"
								href="https://www.linkedin.com/ad-library/home"
								target="_blank"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="1.5"
									/>
								</svg>
								Linkedin Ad Library
							</a>
						</li>
					</ul>
					<span class="small">
						You can save Ads from the above Ad Libraries via our Chrome
						extension.
					</span>
				</slot>
			</div>
		</transition>
	</div>
</template>

<script>
import Popup from '@swipekit/components/popup';
import Avatar from './avatar';
import ExtensionStatus from './extension-status';

export default {
	components: {
		Avatar,
		Popup,
		ExtensionStatus,
	},

	data: function () {
		return {
			offset: [0, 32],
			init: false,
			popup: false,
			showMenu: false,
		};
	},

	props: {
		menu: {},
	},

	computed: {
		user: function () {
			return this.$store.getters['users/user'];
		},
		menuTarget: function () {
			return this.menu;
		},
	},

	methods: {
		onLogout: function () {
			this.showMenu = false;
			// add a small delay for ux purposes
			setTimeout(() => {
				this.$store.dispatch('users/logout');
			}, 50);
		},
		onBoardClick: function () {
			this.$store.dispatch('app/toggleSidebar');
		},
		toggleMenu: function () {
			this.$nextTick(() => {
				this.showMenu = !this.showMenu;
			});
		},
		closeMenu: function () {
			this.showMenu = false;
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		onUploadAds: function () {
			this.$store.dispatch('ads/setAdd', 1);
		},
		onCreateBoard: function () {
			this.$store.dispatch('boards/setAdd', 1);
		},
	},
};
</script>

<style lang="scss">
.c-popup {
	position: absolute;
	top: 42px;
	left: var(--margin);
	width: calc(100% - var(--margin) * 2);
	height: auto;
	background: transparent;
	pointer-events: none;
	box-shadow: none;

	&__arrow {
		//display: none;
		color: var(--color-bg-99);
	}

	&__inner {
		pointer-events: none;
		background: var(--color-bg-99);
		border-radius: var(--border-radius-lg);
		box-shadow: var(--box-shadow);

		> a {
			display: grid;
			grid-template-columns: 32px 1fr;
			align-items: center;
			padding: 0 var(--margin-lg);
			padding-top: var(--margin);
			color: #ededed;
			text-decoration: none !important;

			img {
				width: 32px;
				height: 32px;
				border-radius: 99px;
				object-fit: cover;
				object-position: center center;
			}

			> article {
				padding: var(--margin);

				p {
					margin: 0;
					line-height: 1.3;
				}

				span {
					display: block;
					padding: 0;
					line-height: 1.1;
				}
			}
		}

		span {
			display: inline-block;
			padding: var(--spacer-sm);
			padding-top: var(--margin);
			font-size: var(--font-size-xs);
			color: #ededed;
			opacity: 0.6;
		}
	}

	h6 {
		color: #c5c5c5;
		padding: var(--margin-lg) 12px 0 12px;
		margin: 0;
	}

	ul {
		width: 100%;
		display: inline-block;
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			margin: var(--margin-sm) var(--margin);
			padding-left: 0;

			&:before {
				content: none;
			}

			.btn {
				width: 100%;
				justify-content: flex-start;
			}
		}
	}

	.btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: var(--margin);
		margin-right: var(--margin);
		background-color: rgba(255, 255, 255, 0);
		border-radius: 5px;
		font-size: var(--font-size-sm);
		color: #ededed;
		line-height: 1;

		svg {
			width: 18px;
			height: 18px;
			margin-right: var(--margin);
			color: #fff;
		}

		&:hover,
		&:active,
		&.active {
			box-shadow: none !important;
			background-color: var(--color-bg-96) !important;
			color: #fff;
		}

		&:focus {
			box-shadow: none !important;
		}
	}

	&.active {
		.c-popup__inner {
			pointer-events: all;
		}
	}
}
</style>
